export const SETTINGS_SECTIONS = {
  carriers: 'settings-carriers',
  labels: 'settings-labels',
  orders: 'settings-orders',
  subsidiaries: 'settings-subsidiaries',
  team: 'settings-team',
  history: 'settings-history',
} as const;
